import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';
import { ContractExtension } from './contract-extension.interface';

export class ContractExtensionService {
   async getContractExtensions(customerId: number, employeeId: number, query: LocationQuery) {
      return await http
         .get<PaginatedResponse<ContractExtension>>(`/customers/${customerId}/employees/${employeeId}/contract-extensions`, {
            params: { ...query },
         })
         .then((response) => response.data);
   }
   async getContractExtension(customerId: number, employeeId: number, contractExtensionId: number) {
      return await http
         .get<ContractExtension>(`/customers/${customerId}/employees/${employeeId}/contract-extensions/${contractExtensionId}`)
         .then((response) => response.data);
   }
   async postContractExtension(customerId: number, employeeId: number, contractExtension: ContractExtension) {
      return await http
         .post<ContractExtension>(`/customers/${customerId}/employees/${employeeId}/contract-extensions`, contractExtension)
         .then((response) => response.data);
   }
   async putContractExtension(customerId: number, employeeId: number, contractExtensionId: number, contractExtension: ContractExtension) {
      return await http
         .put<ContractExtension>(
            `/customers/${customerId}/employees/${employeeId}/contract-extensions/${contractExtensionId}`,
            contractExtension,
         )
         .then((response) => response.data);
   }
   async deleteContractExtension(customerId: number, employeeId: number, contractExtensionId: number): Promise<void> {
      return await http
         .delete<void>(`/customers/${customerId}/employees/${employeeId}/contract-extensions/${contractExtensionId}`)
         .then((response) => response.data);
   }
}
